import { css, keyframes } from 'styled-components';

export const pulse = keyframes`
  0% {
    background-size: 98px 98px;
  }
  50% {
    background-size: 272px 272px;
  }
  100% {
    background-size: 98px 98px;
  }
`;

export const drop = keyframes`
  0% {
    background-position: center top;
    background-size: 50%;
    opacity: 0;
  }
  10% {
    opacity: 1;
    background-size: 100%;
  }
  40% {
    opacity: 1;
    background-size: 100%;
  }
  50% {
    background-position: center bottom;
    background-size: 50%;
    opacity: 0;
  }
  100% {
    background-position: center bottom;
    background-size: 50%;
    opacity: 0;
  }
`;

export const glare = keyframes`
  0% {
    transform: rotate(0deg);
  }
  90% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const swingBg = keyframes`
  0% {
    background-position: left top 40%;
  }
  50% {
    background-position: left 100% top 40%;
  }
  100% {
    background-position: left top 40%;
  }
`;

export const swing = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-20%);
  }
  100% {
    transform: translateX(0);
  }
`;

export const lightAnimation = css`
  ${pulse} 5s infinite ease-in-out;
`;

export const catGlareAnimation = css`
  ${glare} 2s infinite linear;
`;

export const backgroundAnimation = css`
  ${swingBg} 20s infinite ease-in-out;
`;

export const smokeAnimation = css`
  ${swing} 6s infinite ease-in-out;
`;

export const speckDropAnimation = css`
  ${drop} infinite ease-in-out;
`;